import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import { BaseBackResponse } from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/explode`;

export interface WorkflowModuleSummary {
  id?: string;
  definitionId?: string;
  referencedModuleType?: string;
  wave: number;
  parameters?: Record<string, string | undefined>;
}

export interface ExplodeFileCommandPayload {
  fileId: string;
  sessionId?: string;
  module?: WorkflowModuleSummary;
  fromState?: string;
  toState?: string;
  comment?: string;
  toCustomerComment?: string;
}

export interface ExplodeFileCommandResponse extends BaseBackResponse {
  value?: string[];
}

const explodeFileCommand = async ({
  fileId,
  sessionId,
  module,
  fromState,
  toState,
  comment,
  toCustomerComment,
}: ExplodeFileCommandPayload): Promise<ExplodeFileCommandResponse> => {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId);

    const response = await apiCall<ExplodeFileCommandResponse>(url, {
      method: SUPPORTED_METHODS.PUT,
      json: {
        sessionId,
        module,
        fromState,
        toState,
        comment,
        toCustomerComment,
      },
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error) as ExplodeFileCommandResponse;
  }
};

export default explodeFileCommand;
